export default __webpack_public_path__ + "contentmodules/UCS_Sign_In_Platinum.9786b97b.png";